import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux'
import TInputForm from "../common/TInputForm";
import classnames from 'classnames';
import { prependAtRootCategory, updateRootCategoryLabel } from '../../actions/category'
import {validateCategoryName} from "./Utils"

function EditButtons({ validated, onCancel, onSubmit }) {
  return (
    <div className="order_btn">
      <button type="button" className="btn_cancel" onClick={onCancel}>취소</button>
      <button type="button" disabled={!validated} className={classnames('btn_default', { 'btn_off':!validated})} onClick={onSubmit}>확인</button>
    </div>
  )
}

function EditForm({ onClose }) {
  const rootLabel = useSelector(state => state.category.rootCategoryLabel)
  const dispatch = useDispatch()

  const [name, setName] = useState(rootLabel)
  const [validated, setValidated] = useState(false)

  function handleSubmit() {
    dispatch(updateRootCategoryLabel(name))
    onClose()
  }

  useEffect(() => {
    setValidated(
      rootLabel != name.trim() &&
      validateCategoryName(name.trim())
    )
  }, [name])

  return (
    <div className="edit_item">
      <label className="lab_tf">
        <strong className="screen_out">카테고리 Label</strong>
        <TInputForm
          className="tf_blog" type="text" maxlength="40"
          value={name} onChange={setName}
        />
      </label>
      <EditButtons
        validated={validated}
        onCancel={onClose}
        onSubmit={handleSubmit}
      />
    </div>
  )
}


function BodyItem({editMode, onChangeEditMode}) {
  if (editMode) {
    return (
      <EditForm
        onClose={() => onChangeEditMode(false)}
      />
    )
  }

  const rootLabel = useSelector(state => state.category.rootCategoryLabel)
  const dispatch = useDispatch()

  function handlePrependAtRootCategory(e) {
    e.preventDefault()
    dispatch(prependAtRootCategory())
  }

  function handleChangeEditMode(e) {
    e.preventDefault()
    onChangeEditMode(true)
  }

  return (
    <div className="basic_item">
      <div className="wrap_drag wrap_all">
        <span className="ico_blog ico_drag ico_all"/>
      </div>
      <span className="txt_name">{rootLabel}</span>
      <div className="info_btn">
        <a href="#" className="btn_post" onClick={handlePrependAtRootCategory}>추가</a>
        <a href="#" className="btn_post" onClick={handleChangeEditMode}>수정</a>
      </div>
    </div>
  )
}

export default function RootNode() {
  const [editMode, setEditMode] = useState(false)

  function handleChangeEditMode(value) {
    setEditMode(value)
  }

  return (
    <div className="bundle_item">
      <div className={classnames('item_order', {'item_edit' : editMode })}>
        <BodyItem
          editMode={editMode}
          onChangeEditMode={handleChangeEditMode}
        />
      </div>
    </div>
  )
}
